import api from '@/utils/api';

/**
 * Create a new category
 * @param {object} categoryData - The category data
 * @returns {Promise}
 */
const createCategoryApi = (categoryData) => api.post('/category', categoryData);

export default createCategoryApi;
